import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import legalEntityCnaeRead from './legalEntityCnaeRead.action.json' assert { type: 'json' }

const legalEntityCnaeReadDefinition = defineReadAutoAction(legalEntityCnaeRead, 'legalEntityCnae')

export default legalEntityCnaeReadDefinition
